module.exports = __webpack_public_path__ + "img/scofield.a08b726f.png";